import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { WaitConfirmContentCard } from './WaitConfirmContentCard';
import { Empty, Pagination } from 'antd';

export const WaitConfirmView = (props) => {
  const { items, pagination, onPageChange } = props;

  const paginatedItems = useMemo(() => {
    if (!items || !Array.isArray(items)) return [];

    const { currentPage, pageSize } = pagination;
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    return items.slice(startIndex, endIndex);
  }, [items, pagination]);

  const MemoizedCard = React.memo(WaitConfirmContentCard);

  return (
    <div>
      {items && Array.isArray(items) && items.length > 0 ? (
        <>
          <div>
            {paginatedItems.map((item, index) => (
              <MemoizedCard key={item.id || index} item={item} />
            ))}
          </div>

          <div
            style={{
              textAlign: 'center',
              marginTop: '20px',
              marginBottom: '20px',
              padding: '10px',
              backgroundColor: 'white',
              borderRadius: '8px',
            }}
          >
            <Pagination
              current={pagination.currentPage}
              pageSize={pagination.pageSize}
              total={items.length}
              onChange={onPageChange}
              showSizeChanger
              pageSizeOptions={['5', '10', '20', '50']}
              showTotal={(total) => `ทั้งหมด ${total} รายการ`}
            />
          </div>
        </>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </div>
  );
};

WaitConfirmView.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      productImageUrl: PropTypes.string,
      warrantyId: PropTypes.number,
      warrantyCode: PropTypes.string,
      mobileModelName: PropTypes.string,
      productName: PropTypes.string,
      channelBuyName: PropTypes.string,
      fullName: PropTypes.string,
      telephone: PropTypes.string,
      createDate: PropTypes.string,
      expireDate: PropTypes.string,
      warrantyStatus: PropTypes.string,
    }),
  ),
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    total: PropTypes.number,
  }),
  onPageChange: PropTypes.func,
};

WaitConfirmView.defaultProps = {
  items: null,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  },
  onPageChange: () => {},
};
